import { useCustomToast } from '@nexelem/snackbar';
import { useCustomTranslation } from '../../../../../hooks';
import { useMutation } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../../../../../routes/config';
import { useGraphneAPI } from '@nexelem/graphne-api';

export const useApplySimulationMutation = () => {
  const api = useGraphneAPI();
  const { tWrapper } = useCustomTranslation('products.simulationPlan');
  const displayToast = useCustomToast();
  const navigate = useNavigate();

  return useMutation({
    mutationFn: (simulationId: number) =>
      api.postGraphneSimulationApply({
        simulationApplyView: {
          simulationId,
        },
      }),
    onSuccess: () => {
      navigate(ROUTES.plan.path);
      displayToast({
        toastType: 'success',
        message: tWrapper('simulationApplied'),
      });
    },
    onError: () => {
      displayToast({
        toastType: 'error',
        message: tWrapper('simulationApplyError'),
      });
    },
  });
};
